import React, { useState } from 'react';
import FormModal from 'components/FormModal';
import Selector from 'components/DesignSystem/Selector';
import Button from 'components/DesignSystem/Button';
import TitleSemiBold from 'components/Typography/TitleSemiBold';
import AlertsCollection from 'components/AlertsCollection';
import Group from './Group';
import Location from './Location';

import './index.scss';

export default function EditGroupLocationForm({
  show,
  onHide,
  groups,
  locations,
  deleteGroup,
  deleteLocation,
  updateGroup,
  updateLocation,
  alert,
}: {
  show: boolean;
  onHide: () => void;
  groups: any;
  locations: any;
  deleteGroup: (groupId: number) => void;
  deleteLocation: (locationId: number) => void;
  updateGroup: any;
  updateLocation: any;
  alert: any;
}) {
  const [groupId, setGroupId] = useState(-1);
  const group = groups?.find((g) => g.id === groupId);

  const availableLocations = locations?.filter((l) => l.groupId === groupId);

  return (
    <div>
      <FormModal show={show} onHide={onHide} title="Editar cadastro" dialogClassName="modal-dialog-centered">
        {alert && (
          <div className="mb-4">
            <AlertsCollection alerts={[alert]} />
          </div>
        )}
        <div className="location-edit">
          <Selector
            label="Editar grupo"
            placeholder="Grupo"
            value={groupId}
            setValue={setGroupId}
            search
            asBlock
          >
            {groups?.map((g) => (
              <option key={g.id} value={g.id}>{g.name}</option>
            ))}
          </Selector>
          {group && (
            <div>
              <Group key={group.id} group={group} onEdit={updateGroup} onDelete={deleteGroup} />
              <div className="mt-3">
                <TitleSemiBold>Locais</TitleSemiBold>
                {availableLocations?.map((l) => (
                  <Location
                    key={l.id}
                    location={l}
                    onEdit={updateLocation}
                    onDelete={deleteLocation}
                  />
                ))}
                {(!availableLocations || availableLocations.length === 0) && (
                  <p className="mt-3">Não há locais cadastrados.</p>
                )}
              </div>
            </div>
          )}
        </div>
        <hr />
        <div className="d-flex justify-content-end">
          <Button onClick={onHide}>Fechar</Button>
        </div>
      </FormModal>
    </div>
  );
}
